import { render, staticRenderFns } from "./ArchiveShardList.vue?vue&type=template&id=435f8716&"
import script from "./ArchiveShardList.vue?vue&type=script&lang=ts&"
export * from "./ArchiveShardList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports